import React from 'react';
import { ArrowUpRight } from 'lucide-react';
export function Footer() {
  return <footer className="bg-charcoal text-bone py-12 px-4 md:px-8" data-id="element-259" data-mp="3gf96t1ka0gbl">
      <div className="max-w-[1400px] mx-auto flex flex-col md:flex-row justify-between items-start md:items-center gap-8" data-id="element-260" data-mp="3ggk7utmc79z0">
        <div data-id="element-261" data-mp="36pfs3rou7l34">
          <img src="https://cdn.magicpatterns.com/uploads/krogWKC6bDwbBogQ4HpBCV/TEFOS_LOGO.png" alt="TEFOS — El bosque es futuro" className="h-12 w-auto mb-4 brightness-0 invert" data-id="element-262" data-mp="36p6bgupomqa3" />
          <p className="text-bone/60 text-sm font-light" data-id="element-263" data-mp="38qw2zmvrtrp">
            © {new Date().getFullYear()} Programa TEFOS · Todos los derechos
            reservados.
          </p>
        </div>

        <div className="flex flex-wrap gap-6 md:gap-12 text-sm font-medium" data-id="element-264" data-mp="3lggez1qbzhis">
          <a href="#inicio" className="hover:text-clay transition-colors" data-id="element-265" data-mp="3qbvnrf9hen8c">
            Inicio
          </a>
          <a href="#hitos" className="hover:text-clay transition-colors" data-id="element-266" data-mp="29xvqyd5xndpb">
            Avances
          </a>
          <a href="#resultados" className="hover:text-clay transition-colors" data-id="element-267" data-mp="2ew716p053q82">
            Resultados
          </a>
          <a href="#noticias" className="hover:text-clay transition-colors" data-id="element-268" data-mp="3gagzjp259b3q">
            Noticias
          </a>
        </div>

        <div className="flex gap-4" data-id="element-269" data-mp="3v89fgibls1ig"></div>
      </div>
    </footer>;
}